import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["tabItem", "tabField", "tabLabel"];

  selectTab(event) {
    this.tabItemTargets.forEach((item) =>
      item.classList.remove("tabs__tab--active"),
    );
    const selected = event.target.closest(".tabs__tab");
    if (selected !== null) {
      selected.classList.add("tabs__tab--active");
    }

    this.tabFieldTargets.forEach((field) =>
      field.classList.remove("tabs__content--active"),
    );
    const selectedField = this.tabFieldTargets.find(
      (field) => field.dataset.lang === event.target.dataset.lang,
    );
    selectedField.classList.add("tabs__content--active");

    this.tabLabelTarget.attributes["for"].value = this.element.querySelector(
      ".tabs__content--active trix-editor",
    ).id;
  }
}
